<!-- <div [ngClass]="{'fixed-menu': isSticky}" class="container-fluid"> -->
<div class="container-fluid">
  <div class="row d-flex justify-content-center">
    <div class="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-10 col-xxl-10 d-flex">
        <!-- Logo Section -->
        <div class="col-md-4 col-2 d-flex align-items-center">
          <div class="d-flex justify-content-start align-items-center go-back-btn-style">
            <p class="mb-0" style="cursor: pointer;" (click)="goBack()">{{goBackText}}</p>
          </div>
        </div>
        <div class="col-md-4 col-2 d-flex align-items-center justify-content-center">
          <div class="w-180-75px d-flex justify-content-between align-items-center">
            <img 
              style="cursor: pointer;"
              (click)="goHome()"
              alt="VectorI3179"
              src="/assets/external/LogoFull.svg"
              class="img-fluid" style="width: 180px;"
            />
          </div>
        </div>
        <div class="col-md-2 col-3 d-flex align-items-center">
          <div class="d-flex justify-content-center align-items-center " style="flex-direction: column;">
            <p class="mb-0 go-back-btn-style go-back-btn-style--light">Contáctanos</p>
            <a class="mb-0 go-back-btn-style text-decoration-none" href="tel:+13057790248">+1 (305) 779-0248</a>
          </div>
        </div>
        <div class="col-md-2 col-3 d-flex align-items-center justify-content-center">
          <div class="d-flex justify-content-start align-items-center w-100 px-2 px-lg-0">
            <button type="submit" class="btn btn-primary continue-btn-steps py-3">Cotizar Seguro</button>
          </div>
        </div>
    </div> 
  </div>
</div>